import { Module } from "state/Module"
import * as Types from "state/gql/_types"

export const ExtensionModule = new Module<Types.ExtensionFragment, Types.GetExtensionsQueryVariables, Types.Extensions_Insert_Input>({
    sortKey: 'extension_number',
    sortOrder: 'asc'
})